import { Controller, useFormContext } from "react-hook-form";

import FormToggleField from "ds/components/Form/ToggleField";

type FormIsSecretFieldProps = {
  name: string;
};

const FormIsSecretField = ({ name }: FormIsSecretFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormToggleField
          variant="switch"
          onChange={field.onChange}
          checked={field.value}
          title="Mark as secret"
          description="Secret values are only made available to Runs and Tasks and are not accessible in the web GUI and through the API. Marking variables as a secret is a recommended option."
        />
      )}
    />
  );
};

export default FormIsSecretField;
